import React, { useState } from "react";
import {
  CustomButton2,
  CustomHourMinutePiker,
  CustomIcon,
  CustomModal,
} from "../../../../components";
import Context from "../../../../context";
import "./index.scss";
import { Container, Row } from "react-bootstrap";
import Column from "../../../../components/CustomView/Column";
import { IItem, ITime } from "../../../../types/common.interface";
import CustomDropDownSearch from "../../../../components/CustomDropDownSearch";
import { WEEK_DAY } from "../../../../values/dropdownItems";
import { IArea } from "../../../../types/provinceCity.interface";

const Create = () => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { showModal, setShowModal, createWorkTime, allArea, loading } =
    React.useContext(Context.WorkTimeScreen);

  const [selectedArea, setSelectedArea] = useState<IArea>();
  const [selectedDay, setSelectedDay] = useState<IItem>();
  const [endTime, setEndTime] = useState<ITime>();
  const [startTime, setStartTime] = useState<ITime>();
  const [errors, setErrors] = useState<any>({
    startTime: "",
    endTime: "",
    day: "",
  });

  // function submitCarInformation(event: ICreateAndUpdateDriver) {
  //   updateFunction!({ ...formData, ...event });
  // }

  const submitHandler = async () => {
    let fieldErrors = { day: "", startTime: "", endTime: "", area: "" };

    if (!selectedDay)
      fieldErrors = { ...fieldErrors, day: "انتخاب روز اجباری است" };
    if (!startTime?.hour && !startTime?.minute)
      fieldErrors = {
        ...fieldErrors,
        startTime: "شروع ساعت کاری اجباری است",
      };
    if (!endTime?.hour && !endTime?.minute)
      fieldErrors = {
        ...fieldErrors,
        endTime: "پایان ساعت کاری اجباری است",
      };
    if (!endTime?.hour && !endTime?.minute)
      fieldErrors = {
        ...fieldErrors,
        area: "انتخاب محدوده کاری اجباری است",
      };
    setErrors(fieldErrors);

    if (
      fieldErrors?.day === "" &&
      fieldErrors?.startTime === "" &&
      fieldErrors?.endTime === "" &&
      fieldErrors?.area === ""
    ) {
      const result = await createWorkTime!({
        dayName: selectedDay?.value as string,
        city: selectedArea?._id,
        dayNumber: selectedDay?._id,
        endTime:
          (endTime?.hour ? endTime?.hour : "00") +
          ":" +
          (endTime?.minute ? endTime?.minute : "00"),
        startTime:
          (startTime?.hour ? startTime?.hour : "00") +
          ":" +
          (startTime?.minute ? startTime?.minute : "00"),
      });
      if (result) {
        setSelectedDay(undefined);
        setStartTime(undefined);
        setEndTime(undefined);
        setSelectedArea(undefined);
      }
    }
  };

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <section id="create-work-time-modal-container">
      <CustomIcon
        icon="fa fa-add"
        onClick={() => setShowModal!("CREATE")}
        size="medium"
        hoverTitle="ایجاد ساعت کاری"
      />
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "CREATE"}
        minWidth={"50rem"}
        minHeight={"22vh"}
      >
        <form>
          <Container>
            <Row className="row-start">
              <Column medium={2} className="dropdown">
                <CustomDropDownSearch
                  itemName="name"
                  items={allArea?.data?.result}
                  defaultItem={selectedArea}
                  onSelectItem={(event) => {
                    setSelectedArea(event);
                    setErrors({ ...errors, area: "" });
                  }}
                  placeHolder="منطقه"
                  label="منطقه"
                />
              </Column>
              <Column medium={2} className="dropdown">
                <CustomDropDownSearch
                  itemName="name"
                  items={WEEK_DAY}
                  defaultItem={selectedDay}
                  onSelectItem={(event) => {
                    setSelectedDay(event);
                    setErrors({ ...errors, day: "" });
                  }}
                  placeHolder="روز"
                  label="روز"
                />
              </Column>
              <Column medium={3} className="dropdown">
                <label className="form-label">شروع</label>
                <CustomHourMinutePiker
                  time={startTime as ITime}
                  onChangeTime={(event: ITime) => {
                    setStartTime(event);
                    setErrors({ ...errors, startTime: "" });
                  }}
                  //isDisable={props.defaultValue?.close}
                />
              </Column>
              <Column medium={3} className="dropdown">
                <label className="form-label">پایان</label>
                <CustomHourMinutePiker
                  time={endTime as ITime}
                  onChangeTime={(event: ITime) => {
                    setEndTime(event);
                    setErrors({ ...errors, endTime: "" });
                  }}
                  //isDisable={props.defaultValue?.close}
                />
              </Column>
            </Row>
            <Row className="row-start">
              <Column medium={4} className="dropdown">
                <div className="error">{errors?.day}</div>
              </Column>
              <Column medium={3} className="dropdown">
                <div className="error">{errors?.startTime}</div>
              </Column>
              <Column medium={3} className="dropdown">
                <div className="error">{errors?.endTime}</div>
              </Column>
            </Row>
            <Row className="button-row">
              <Column>
                <CustomButton2
                  title={"ثبت"}
                  type="primary"
                  onClick={submitHandler}
                  isLoading={loading}
                />
              </Column>
            </Row>
          </Container>
        </form>
      </CustomModal>
    </section>
  );
};

export default Create;
